import { gql } from '@apollo/client';


const DELETE_NEWS_POST = gql`
mutation deleteNewsPost($siteNewsId:ID!){
	newsContext{
		deleteNewsPost(siteNewsId:$siteNewsId){
			errorResult
			{
				data
				{
					key
					value
				}
				errorCode
				errorMessage
			}
			success
		}
	}
}
`;

export default DELETE_NEWS_POST;
